import axios from 'axios';

const CONTENT_TYPE = 'application/json';
const {
  CLIENT_ID, CLIENT_SECRET, API_URL, WRV_CLIENT_ID, WRV_CLIENT_SECRET,
} = process.env;

axios.defaults.baseURL = API_URL;
// axios.defaults.baseURL = '/api/2.0/';
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Content-Type'] = CONTENT_TYPE;
axios.defaults.headers.common['client-id'] = CLIENT_ID;
axios.defaults.headers.common['client-secret'] = CLIENT_SECRET;

// Set Axios common headers.
export const axiosLogin = axios.create({
  baseURL: process.env.NODE_API_URL || `https://${process.env.ENVIRONMENT === 'PRODUCTION' ? '' : 'staging.'}api.teambuildr.com/`,
  headers: {
    common: {
      Platform: 'Webapp',
      AppVersion: '1.1.0',
    },
  },
});

axiosLogin.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axiosLogin.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

export const axiosAuthed = axios.create({
  baseURL: process.env.NODE_API_URL || `https://${process.env.ENVIRONMENT === 'PRODUCTION' ? '' : 'staging.'}api.teambuildr.com/`,
  headers: {
    common: {
      Platform: 'Webapp',
      AppVersion: '1.1.0',
    },
  },
  // isRetry: false,
});

// Create Axios client for unauthenticated requests
export const axiosUnauthed = axios.create({
  baseURL: process.env.NODE_API_URL || `https://${process.env.ENVIRONMENT === 'PRODUCTION' ? '' : 'staging.'}api.teambuildr.com/`,
  headers: {
    common: {
      Platform: 'Webapp',
      AppVersion: '1.1.0',
    },
  },
});

// Create Axios client for reset password requests
export const axiosReset = axios.create({
  baseURL: process.env.NODE_API_URL || `https://${process.env.ENVIRONMENT === 'PRODUCTION' ? '' : 'staging.'}api.teambuildr.com/`,
  headers: {
    common: {
      Platform: 'Webapp',
      AppVersion: '1.1.0',
    },
  },
});

// Axios client specific to WRV. Contains specific client keys.
export const axiosWRV = axios.create({
  baseURL: process.env.NODE_API_URL || `https://${process.env.ENVIRONMENT === 'PRODUCTION' ? '' : 'staging.'}api.teambuildr.com/`,
  headers: {
    common: {
      Platform: 'Webapp',
      AppVersion: '1.1.0',
    },
  },
  // isRetry: false,
});
axiosWRV.defaults.headers.common['Content-Type'] = CONTENT_TYPE;
axiosWRV.defaults.headers.common['client-id'] = WRV_CLIENT_ID;
axiosWRV.defaults.headers.common['client-secret'] = WRV_CLIENT_SECRET;

axiosReset.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axiosReset.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
// eslint-disable-next-line dot-notation
axiosReset.defaults.headers.common['client_id'] = CLIENT_ID;
// eslint-disable-next-line dot-notation
axiosReset.defaults.headers.common['client_secret'] = CLIENT_SECRET;

// Create Axios client for registration requests
// Is this necessary? Seems like unathed would get the same thing done if we DON'T need the headers.
export const axiosRegister = axios.create({
  baseURL: process.env.NODE_API_URL || `https://${process.env.ENVIRONMENT === 'PRODUCTION' ? '' : 'staging.'}api.teambuildr.com/`,
  headers: {
    common: {
      Platform: 'Webapp',
      AppVersion: '1.1.0',
    },
  },
});

axiosRegister.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axiosRegister.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axiosRegister.defaults.headers.common['client-id'] = CLIENT_ID;
axiosRegister.defaults.headers.common['client-secret'] = CLIENT_SECRET;
